import { Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { BottomNav } from "./BottomNav";
import { StickyCart } from "@/components/StickyCart";

export default function Layout() {
  const { pathname } = useLocation();
  const hideSticky = ["/cart", "/checkout", "/login"].some((p) => pathname.startsWith(p));
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 pb-safe"><Outlet /></main>
      <Footer />
      {!hideSticky && <StickyCart />}
      <BottomNav />
    </div>
  );
}
